import { HexLocator, SpecialVersionType } from "@hex/common";

import { Routes } from "../../../route/routes.js";
import { getHexRoute } from "../../hex-list-2/hex-row/utils.js";

export const getRelativeUrlForExplore = (hexLocator: HexLocator): string => {
  return Routes.EXPLORE.getUrl({ hexLocator });
};

export const getRelativeUrlForProject = (
  route: ReturnType<typeof getHexRoute>,
  hexLocator: HexLocator,
  version: SpecialVersionType,
): string => {
  return route.getUrl({ version, hexLocator });
};
